import React, { useState } from 'react';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

type ListOption = { id: string; name: string; imageFilePath?: string };

interface ListDropdownProps {
	title: string;
	alwaysOpen?: boolean;
	listOptions: ListOption[];
	selectedItem: string;
	handleItemSelected: (id: string) => void;
}

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function ListDropdown(props: ListDropdownProps) {

	// states.

	const [isOpen, setIsOpen] = useState(props.alwaysOpen);
	const [selectedName, setSelectedName] = useState<string | null>(null);

	// handlers.
	
	// toggles the panel between open and closed.
	const handleShrinkExpandButtonClicked = () => {
		if (!props.alwaysOpen) {
			setIsOpen(!isOpen);
		}
	};

	// handles an item being selected.
	const handleItemSelected = (id: string, name: string) => {

		// invoke the callback to update the selected item in the parent component.
		props.handleItemSelected(id);

		// if the dropdown should not always be open...
		if (!props.alwaysOpen) {

			// update the selected name, splitting on the <br> tag if it exists to support multi-line names.
			// n.b. this is a bit of a hack to support multi-line names without having to add additional properties to the list options, so re-do at some point!!
			const names = name.split('<br>', 2);
			setSelectedName(names[0] ? names[0] : names[1]);

			// close the dropdown.
			setIsOpen(false);
		}
	};

	// return the HTML.
	return (
		<div className={`list-dropdown-container${isOpen ? ' open' : ''}`}>
			<div className="list-dropdown-title" onClick={handleShrinkExpandButtonClicked}>
				<p>{props.title}</p>
				{!props.alwaysOpen && (
					<a role="button" onClick={handleShrinkExpandButtonClicked}>
						{isOpen ? (
							<img src={'assets/images/icons/up-arrow-white.svg'} width="20" height="12" alt="Close Panel" />
						) : (
							<img src={'assets/images/icons/down-arrow-white.svg'} width="20" height="12" alt="Open Panel" />
						)}
					</a>
				)}
				{selectedName && <p>{selectedName}</p>}
			</div>
			<div className="dropdown-list">
				{props.listOptions.map((option: ListOption, index: number) => {
					return (
						<div
							key={`${option.id}-${index}`}
							className={`list-item${props.selectedItem === option.id ? ' selected' : ''}`}
							style={{ justifyContent: option.imageFilePath ? '' : 'center' }}
							onClick={() => handleItemSelected(option.id, option.name)}
						>
							{option.imageFilePath && <img className="list-item-image" width="30" height="30 " src={option.imageFilePath} alt={option.name} />}
							<p dangerouslySetInnerHTML={{ __html: option.name }}></p>
						</div>
					);
				})}
			</div>
		</div>	
	);
}
